import { render, staticRenderFns } from "./Light.vue?vue&type=template&id=ffbb1b5c&scoped=true"
import script from "./Light.vue?vue&type=script&lang=js"
export * from "./Light.vue?vue&type=script&lang=js"
import style0 from "./Light.vue?vue&type=style&index=0&id=ffbb1b5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffbb1b5c",
  null
  
)

export default component.exports